module.exports = __webpack_public_path__ + "img/banner2.3ec1eb21.png";